// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"hero-image_imageContainer__bg__b","isShownOnMobile":"hero-image_isShownOnMobile__pzD2b"};